import { rootApi } from "../../api/rootApi";

export const ecommerceTagsApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    // Fetch all ecommerce tags
    fetchEcommerceTags: builder.mutation({
      query: ({ slug, token, ...body }) => ({
        url: `/tenant/ecommerce/tags/all`,
        method: "POST",
        headers: {
          slug,
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body,
      }),
    }),

    // Add new ecommerce tag
    addEcommerceTag: builder.mutation({
      query: ({ slug, token, ...body }) => ({
        url: `/tenant/ecommerce/tags/add`,
        method: "POST",
        headers: {
          slug,
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body,
      }),
    }),
  }),
});

export const {
  useFetchEcommerceTagsMutation,
  useAddEcommerceTagMutation,
} = ecommerceTagsApi;
